import { PaymentLinkAmountMode } from "enums/PaymentLink";
import { formatCashFull } from "utils/formatCash";

interface AmountParts {
  amountMode: PaymentLinkAmountMode;
  amount?: number;
  minAmount?: number;
  maxAmount?: number;
  currency: string;
}

type Translate = (key: string, options?: Record<string, unknown>) => string;

export const describePaymentLinkAmount = (
  link: AmountParts,
  t: Translate,
): string => {
  if (link.amountMode !== PaymentLinkAmountMode.PAYER_CHOOSES) {
    return formatCashFull(link.amount || 0, link.currency);
  }

  const min =
    link.minAmount != null ? formatCashFull(link.minAmount, link.currency) : "";
  const max =
    link.maxAmount != null ? formatCashFull(link.maxAmount, link.currency) : "";

  if (min && max) return t("AmountRange", { min, max });
  if (min) return t("AmountFrom", { min });
  if (max) return t("AmountUpTo", { max });

  return "-";
};
